// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TusU","content":"styles_content__3x0a6","row":"styles_row__3OHxN","footer":"styles_footer__1-j5p","phraseLength":"styles_phraseLength__2BrPT"};